import React from 'react';
import ProgressBar, { SuccessProgressBar } from '@atlaskit/progress-bar';
import cogIllustration from '../../../assets/confluence-activation/cog-illustration.png';
import * as Styled from './styled';
import { FormattedMessage } from 'react-intl-next';
import messages from './messages';
import Image from '@atlaskit/image';

export type ProgressBarStatus = 'in-progress' | 'completed' | 'not-started' | 'error';
type Props = {
	status: ProgressBarStatus;
};

const ProvisioningProgressBar = ({ status }: Props) => {
	if (status === 'completed') {
		return <SuccessProgressBar value={1} />;
	}

	if (status === 'in-progress') {
		return <SuccessProgressBar value={0.8} />;
	}

	if (status === 'error') {
		return <ProgressBar value={1} appearance="inverse" />;
	}

	return <SuccessProgressBar isIndeterminate />;
};

const ActivationInProgressBackground = ({ status = 'not-started' }: Props) => (
	<Styled.Wrapper>
		<Image height={144} width={144} src={cogIllustration} />
		<Styled.ContentWrapper>
			<ProvisioningProgressBar status={status} />
			<FormattedMessage tagName="h3" {...messages.provisioningBackgroundTitle} />
			<FormattedMessage tagName="p" {...messages.provisioningBackgroundText} />
		</Styled.ContentWrapper>
	</Styled.Wrapper>
);

export default ActivationInProgressBackground;
